import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { get } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "enrollments";

type GetCoreEnrollmentStatusYearlyProps = {
	planName: string;
	startDate: string;
	endDate: string;
};

export const getCoreEnrollmentsYearlyStatus = async (_apiPayload: GetCoreEnrollmentStatusYearlyProps) => {
	const { planName, startDate, endDate } = _apiPayload;

	try {
		const endpoint = `${initialRoute}/get-core-enrollments-yearlystatus?planName=${encodeURIComponent(
			planName
		)}&startDate=${startDate}&endDate=${endDate}`;
		const token = localStorage.getItem("@jwt");

		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;

			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				// console.log("Responsecheckfortheapi---------->", result);
				return result;
			}
		}

		throw new Error();
	} catch (error: any) {
		if (error.response?.status === StatusCodes.BAD_REQUEST) {
			alert(error.response.data?.message);
		} else if (error.response?.status === StatusCodes.UNAUTHORIZED) {
			alert(error.response.data?.message);
		} else {
			throw error;
		}
	}
};
